import bill from './bills'
import sample from "./sample"
import task from "./task"
import setting from "./setting"
export default {
  ...bill,
  ...sample,
  ...task,
  ...setting
}